<ng-select [items]="countries" placeholder="Country"
           [(ngModel)]="selectedCountry" (ngModelChange)="countryChange($event)"
           bindLabel="value" [appendTo]="appendTo">
    <ng-template ng-option-tmp let-item="item">
        <span>{{item.flag}} {{item.value}}</span>
    </ng-template>
</ng-select>
